<template>
    <v-app>
        <v-app-bar app color="primary" dark>
            <v-toolbar-title>IntimJazz Band</v-toolbar-title>
        </v-app-bar>
        <v-content>
            <v-card class="mx-auto" max-width="800">
                <v-card-text>
                    <h4>Serveur inaccessible, nous sommes sur le qui-vive! Veuillez nous excuser.</h4>
                    <p>{{ errorMsg }}</p>
                    <v-btn block @click="reload()" color="primary" text>Réessayer</v-btn>
                </v-card-text>
            </v-card>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: 'jazz-error',
    computed: {
        errorMsg() {
            return this.currentError.message
        }
    },
    mounted() {
        // eslint-disable-next-line
        console.warn(this.currentError)
    },
    methods: {
        reload() {
            window.location.reload()
        }
    }
}
</script>
